import { oldSelfServiceLink, wdeLink } from 'config';
import { ReactComponent as CustomerSvg } from 'assets/icons/fa-user.svg';
import { ReactComponent as InsightsSvg } from 'assets/icons/fa-chart-area.svg';
import { ReactComponent as OMGSvg } from 'assets/icons/fa-edit.svg';
import { ReactComponent as WDESvg } from 'assets/icons/fa-user-friends.svg';
import { ReactComponent as ToolSvg } from 'assets/icons/fa-tools.svg';
import { ReactComponent as AdminSvg } from 'assets/icons/fa-cog.svg';
import { ReactComponent as SsoSvg } from 'assets/icons/bi-key.svg';
import {
  ssoManagementFeatureFlag,
  suspensionRulesFeatureFlag,
} from './featureFlags';

const sideMenuEntries = [
  {
    name: 'Customers',
    path: '/Customers',
    roles: 'IsAdmin,CanAccessCustomerInfo',
    icon: CustomerSvg,
  },
  {
    name: 'Insights',
    icon: InsightsSvg,
    roles: 'CanAccessReports,CanAccessAnalytics',
    subRoutes: [
      {
        path: '/Reports',
        name: 'Reports',
        roles: 'CanAccessReports',
      },
      {
        name: 'Analytics',
        roles: 'CanAccessAnalytics',
        isExternal: true,
        path: oldSelfServiceLink + '/Analytics/DailyStatus',
      },
    ],
  },
  {
    name: 'OMG',
    icon: OMGSvg,
    roles: 'CanLogonToOMG',
    subRoutes: [
      {
        path: '/OmgSettings',
        name: 'OMG Settings',
        roles: 'CanLogonToOMG',
      },
      {
        path: '/BrandTemplates',
        name: 'Brand Templates',
        roles: 'CanLogonToOMG',
      },
      {
        path: '/AccountTemplates',
        name: 'Account Templates',
        roles: 'CanLogonToOMG',
      },
    ],
  },
  {
    icon: WDESvg,
    name: 'Direct Entry',
    roles: 'CanUseDirectEntry',
    isExternal: true,
    path: wdeLink,
  },
  {
    name: 'Tools',
    roles:
      'CanAccessBulkAccountUpdates,CanUploadCCDailyBuckets,CanAccessForms,CanCreateOneOffInvoices',
    icon: ToolSvg,
    subRoutes: [
      {
        path: '/BulkBusinessIdUpdate',
        name: 'Business ID Update',
        roles: 'CanAccessBulkAccountUpdates',
      },
      {
        path: '/InvoiceUpload',
        name: 'Invoices',
        roles: 'CanCreateOneOffInvoices',
      },
      {
        path: '/UploadCCBuckets',
        name: 'CC Bucket Uploads',
        roles: 'CanUploadCCDailyBuckets',
      },
      {
        path: '/Forms',
        name: 'Forms',
        roles: 'CanAccessForms',
      },
    ],
  },
  {
    name: 'Administration',
    icon: AdminSvg,
    roles: 'IsAdmin,CanConfigureSuspensionRules',
    subRoutes: [
      {
        path: '/UserManagement',
        name: 'User Management',
        roles: 'IsAdmin',
      },
      {
        path: '/GroupManagement',
        name: 'Group Management',
        roles: 'IsAdmin',
      },
      {
        path: '/Settings',
        name: 'Custom Cancellation',
        roles: 'IsAdmin',
      },
      {
        path: '/SuspensionRules',
        name: 'Suspension Rules',
        roles: 'CanConfigureSuspensionRules',
        featureFlag: suspensionRulesFeatureFlag,
        hidden: false,
      },
    ],
  },
  {
    name: 'SSO',
    icon: SsoSvg,
    roles: 'IsAdmin,IsGlobalAdmin,CanManageSSOUsers',
    featureFlag: ssoManagementFeatureFlag,
    subRoutes: [
      {
        path: '/SsoGroupManagement',
        name: 'Group Management',
        roles: 'IsAdmin,IsGlobalAdmin,CanManageSSOUsers',
      },
    ],
  },
];

export default sideMenuEntries;
